/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import * as React from 'react';
import clsx from 'clsx';
import Field from '@data-driven-forms/react-form-renderer/dist/cjs/field';
import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';
type Props = {
  field: Field;
  children?: React.ReactElement;
};
export function ControlsCellWrapper({ field, children }: Props) {
  const { renderForm } = useFormApi();
  const colSpan = field.colSpan && !field.colWidth ? field.colSpan : 1;

  const renderFormWithAddRemoveButton = (field, children?) => {
    if (children) {
      return (
        <div className='flex'>
          <div className='flex-auto'>{renderForm([field])}</div>
          {children}
        </div>
      );
    }
    return renderForm([field]);
  };

  return (
    // TODO: make pad for mt-auto
    <div
      className={clsx(
        !field.className?.includes('mt') ? (field.component !== 'label' ? 'mt-auto' : '') : '',
        `col-span-${colSpan || 1}`,
        field.colStart && ` col-start-${field.colStart}`,
        field.className && field.className
      )}
      key={`${field.name}-wrapper`}
    >
      {renderFormWithAddRemoveButton(field, children)}
    </div>
  );
}
